export default {
  buttonStyles: {
    margin: "0.5rem 0.5rem",
  },
};
